import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles"

export default responsiveFontSizes(
    createMuiTheme({
        sparcaButton: {
            width: "100%",
            maxWidth: "200px",
        },
        spacing: 5,
        palette: {
            primary: {
                main: "#a11c20",
                secondary: "#cc2429",
            },
            secondary: {
                main: "#44546A",
            },
            blue: {
                main: "#0d489b",
            },
            green: {
                main: "#1f6613",
            },
            text: {
                primary: "#000000",
                secondary: "#a11c20",
            },
            sparcaLightBlue: {
                main: "#7288a9",
            },
            sparcaDarkBlue: {
                main: "#44546a",
            },
            sparcaLightGrey: {
                main: "#dcdcdc",
                secondary: "#f1f1f1",
            },
            sparcaDarkGrey: {
                main: "#a7aaa9",
            },
            sparcaLightBlack: {
                main: "#364556",
            },
            sparcaDarkBlack: {
                main: "#161617",
            },
            controlPanelInputGrey: {
                main: "#ffffff33",
            },
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1500,
                // xxl: 1400,
            },
        },
        overrides: {
            MuiInputLabel: {
                root: {
                    color: "rgba(0, 0, 0, 1)",
                    borderColor: "orange",
                    "&$focused": {
                        borderColor: "orange",
                    },
                },
            },
            MuiFormLabel: {
                root: {
                    "&$focused": {
                        color: "rgba(0, 0, 0, 1)",
                    },
                },
            },
            MuiOutlinedInput: {
                root: {
                    "&$focused $notchedOutline": {
                        borderColor: "rgba(0, 0, 0, 1)",
                    },
                },
                focused: {},
                notchedOutline: {},
            },
            MuiTypography: {
                gutterBottom: {
                    marginBottom: 16,
                },
            },
            MuiButton: {
                root: {
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    // minWidth: "150px",
                },
                text: {
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    "&:hover": {
                        backgroundColor: "transparent",
                    },
                },
                outlined: {
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderColor: "#000000",
                    color: "#000000",
                    "&:hover": {
                        backgroundColor: "#cc2429",
                        color: "#ffffff",
                    },
                },
                outlinedPrimary: {
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    borderColor: "#000000",
                    color: "#000000",
                    "&:hover": {
                        backgroundColor: "#cc2429",
                        color: "#ffffff",
                    },
                },
                outlinedSecondary: {
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    backgroundColor: "#a7aaa9",
                    borderColor: "#000000",
                    color: "#ffffff",
                    "&:hover": {
                        textDecoration: "underline #ffffff",
                        borderColor: "#000000",
                    },
                },
                containedPrimary: {
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    "&:hover": {
                        backgroundColor: "#cc2429",
                    },
                },
                containedSecondary: {
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    backgroundColor: "#000000",
                    "&:hover": {
                        backgroundColor: "#cc2429",
                    },
                },
            },
        },
        typography: {
            fontFamily: ["Inter", "sans-serif"].join(","),
            // The default font size of the Material Specification.
            fontSize: 16,
            lineHeight: 1.1,
            // fontWeightLight: 300,
            // fontWeightRegular: 400,
            // fontWeightMedium: 500,
            // fontWeightSemiBold: 600,
            // fontWeightBold: 700,
            color: "#a11c20",
            gutterBottom: {
                marginBottom: "15px",
            },
            body1: {
                fontSize: 16,
                lineHeight: 1.1,
            },
            h1: {
                color: "#a11c20",
                lineHeight: 1.1,
                fontWeight: 600,
            },
            h2: {
                color: "#a11c20",
                lineHeight: 1.1,
                fontWeight: 600,
            },
            h3: {
                color: "#a11c20",
                lineHeight: 1.1,
                fontWeight: 600,
            },
            h4: {
                color: "#a11c20",
                lineHeight: 1.1,
                fontWeight: 600,
            },
            h5: {
                color: "#a11c20",
                lineHeight: 1.1,
                fontWeight: 600,
            },
            h6: {
                color: "#a11c20",
                lineHeight: 1.1,
                fontWeight: 600,
                fontSize: "1.25rem",
            },
            // Tell Material-UI what's the font-size on the html element.
            // 16px is the default font-size used by browsers.
            button: {
                maxWidth: "none",
                lineHeight: 1.3,
                paddingTop: "10px",
                paddingBottom: "10px",
            },
        },
    })
)
